import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "utils/RouterManager/screens/Error";
import { reportError } from "utils/reportError";
import { isChunkLoadError, reloadForStaleChunkOnce } from "utils/staleChunkReload";

interface RouteErrorBoundaryProps {
    children: React.ReactNode;
}

/** Keeps the app shell mounted when a lazy route throws during render. */
export const RouteErrorBoundary = ({ children }: RouteErrorBoundaryProps) => {
    const { pathname } = useLocation();

    return (
        <ReactErrorBoundary
            FallbackComponent={ErrorBoundary}
            resetKeys={[pathname]}
            onError={(error, info) => {
                // Render-time safety net: if a lazy route threw because its
                // content-hashed chunk went stale after a deploy, recover with
                // one guarded full-page reload instead of the generic error
                // screen. (The lazyWithReload wrapper catches most of these at
                // import time; this covers the rest.)
                if (isChunkLoadError(error) && reloadForStaleChunkOnce()) {
                    return;
                }
                reportError(error, { componentStack: info.componentStack, source: "route" });
            }}
        >
            {children}
        </ReactErrorBoundary>
    );
};
